export const name = "ST_AREA";
export const summary = `Gets the area covered by the polygons in a \`GEOGRAPHY\` value.`;
export const reference = `
## ST_AREA

Gets the area covered by the polygons in a \`GEOGRAPHY\` value.

\`\`\`
ST_AREA(geography_expression[, use_spheroid])
\`\`\`

### Description

Returns the area in square meters covered by the polygons in the input\`GEOGRAPHY\`.

If \`geography_expression\` is a point or a line, returns zero. If\`geography_expression\` is a collection, returns the area of the polygons in the collection; if the collection doesn't contain polygons, returns zero.

The optional \`use_spheroid\` parameter determines how this function measures distance. If \`use_spheroid\` is \`FALSE\`, the function measures distance on the surface of a perfect sphere.

The \`use_spheroid\` parameter currently only supports the value \`FALSE\`. The default value of \`use_spheroid\` is \`FALSE\`.


### Return type

\`FLOAT64\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
